
<list-item
  class="card-list-item"
  :card="card"
  v-bind="$attrs"
  v-on="$listeners"
>
  <template #image>
    <card-image :image-url="card.imageCustom || card.image" />
  </template>

  <template #info>
    <card-item-info :card="card">
      <slot />
    </card-item-info>
  </template>
</list-item>
